import { render } from "./MainTitle.vue?vue&type=template&id=2a3c79e8"
const script = {}

import "./MainTitle.vue?vue&type=style&index=0&id=2a3c79e8&lang=less"

import exportComponent from "/opt/jenkins/jenkins_home/workspace/QuickApp_NapH5_YQZK_YiZhiAiChong/yzac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__